import React from 'react';
import { SectionCta } from '../SectionCta';
import { differentPoints } from '../../data/content';
export function Different() {
  return <section className="bg-white px-4 py-16 md:px-8 md:py-24" data-id="element-122" data-mp="3p9bveegju5ic">
      <div className="mx-auto grid max-w-6xl gap-10 lg:grid-cols-[1fr_1.2fr] lg:gap-16" data-id="element-123" data-mp="7ragp381ryhc">
        <div className="lg:sticky lg:top-10 lg:self-start" data-id="element-124" data-mp="2zshajloa5yh">
          <p className="text-sm font-extrabold uppercase tracking-wide text-brand-700" data-id="element-125" data-mp="2y7q93ykh55d">Why this blueprint is different</p>
          <h2 className="mt-3 text-[28px] font-extrabold leading-tight tracking-tight text-ink-900 md:text-4xl" data-id="element-126" data-mp="cqdouwjbqktj">
            You don't need another endodontics textbook.
          </h2>
          <p className="mt-4 text-[17px] leading-relaxed text-mist-600" data-id="element-127" data-mp="qniooesg2ngc">
            You need practical tools that help you organize the assessment and planning process. Traditional educational
            resources often focus on explaining concepts. The Endodontic Retreatment Decision Blueprint™ focuses on
            providing structured tools for professional use.
          </p>
        </div>
        <div data-id="element-128" data-mp="3d1ce8gffsewc">
          <p className="text-sm font-extrabold uppercase text-ink-900" data-id="element-129" data-mp="3i20ezttgwa3r">Built around real workflow needs</p>
          <ol className="mt-4 divide-y divide-mist-200 border-y border-mist-200" data-id="element-130" data-mp="3m3bwfc26tp0v">
            {differentPoints.map((d, i) => <li key={d.title} className="flex gap-5 py-5" data-id="element-131" data-mp="3qvdh9mdf8o2i" data-mpi={i}>
                <span className="text-3xl font-extrabold leading-none text-brand-500" data-id="element-132" data-mp="3vtx21jga3tta">{i + 1}</span>
                <div data-id="element-133" data-mp="4n3snsbc0odo">
                  <h3 className="text-lg font-extrabold text-ink-900" data-id="element-134" data-mp="4matpdim7363">{d.title}</h3>
                  <p className="mt-1 text-[16px] leading-relaxed text-mist-600" data-id="element-135" data-mp="9lx8vsi06thj">{d.body}</p>
                </div>
              </li>)}
          </ol>
          <SectionCta label="I want practical tools, not theory" data-id="element-136" data-mp="dlxupy7fm6ym" />
        </div>
      </div>
    </section>;
}